import { merge } from 'lodash-unified'
import L from 'leaflet'
import { isMobile } from '@map-sdk/hooks'
import { ShipxyOptions } from '@map-sdk/sdk/config'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

export interface Weatherdetail {
  forecastaging: string
  meteorological: string
  winddirection: string
  windpower: string
  waveheight: null
  visibility: string
  meteorological_icon?: string
  imageUrl?: string
  publishtime?: string
}

export interface SeaForecastInterFaca {
  seaarea: string
  publishtime: string
  centerlatitude: string | number
  centerlongititude: string
  weatherdetail: Array<Weatherdetail>
  opacity: number
  offset: number[]
  direction: string
  publishdate: Date | null
  forecastaging_str: any
  meteorological: string
}

/**
 * 海洋预报
 */
class SeaForecast implements SeaForecastInterFaca {
  seaarea = ''
  publishtime = ''
  centerlatitude = ''
  centerlongititude = ''
  meteorological = ''
  opacity = 0.9
  offset = [0, 104]
  direction = 'right'
  weatherdetail: Array<Weatherdetail> = []
  publishdate: Date | null = null
  forecastaging_str: any
}

class SeaAreaForecastService {
  public static ajaxs: XMLHttpRequest[] = []
  private _layerGroup: L.FeatureGroup
  private _map: MyMap
  private _seaForecasts_yanan: SeaForecastInterFaca[] = []
  private _seaForecasts_jinhai: SeaForecastInterFaca[] = []
  private _seaForecasts_yuanhai: SeaForecastInterFaca[] = []
  private _seaForecasts: SeaForecastInterFaca[] = []
  private callbackListener?: (params: any) => void

  constructor(map: MyMap) {
    this._map = map
    this._layerGroup = L.featureGroup().addTo(map)
  }

  /**
   * 添加气象图标显示
   * @param type 1-沿岸天气，2-近海，3-远海 其他图层
   * @param data
   */
  addSeaForecasts(type: number, data: SeaForecast[]) {
    switch (type) {
      //  沿岸天气
      case 1:
        this._seaForecasts_yanan = this._seaForecasts_yanan.concat(data)
        break
      //  近海
      case 2:
        this._seaForecasts_jinhai = this._seaForecasts_jinhai.concat(data)
        break
      //  远海
      case 3:
        this._seaForecasts_yuanhai = this._seaForecasts_yuanhai.concat(data)
        break
      default:
        this._seaForecasts = this._seaForecasts.concat(data)
    }
    this._drawSeaForecasts()
  }

  _drawSeaForecast(data: SeaForecastInterFaca) {
    if (data && data.weatherdetail && data.weatherdetail.length) {
      const imageUrl = this._judgeImage(data.meteorological)
      const iconUrl = `${ShipxyOptions.weather.icon_base_url}/${imageUrl.icon}`
      let icon = L.icon({
        iconUrl,
        iconSize: [25, 25],
      })
      const marker = L.marker(
        L.latLng(Number(data.centerlatitude), Number(data.centerlongititude)),
        {}
      )
      marker.setIcon(icon)
      marker.on('mouseover', () => {
        icon = L.icon({
          iconUrl,
          iconSize: [40, 40],
        })
        marker.setIcon(icon)
        this.callbackListener && this.callbackListener(mobisCbRes)
      })
      marker.on('mouseout', () => {
        icon = L.icon({
          iconUrl,
          iconSize: [25, 25],
        })
        marker.setIcon(icon)
      })
      let width = '250px'
      data
      let url = `${ShipxyOptions.weather.icon_base_url}/${imageUrl.bg24}`
      data.weatherdetail.length > 1 &&
        ((url = `${ShipxyOptions.weather.icon_base_url}/${imageUrl.bg48}`),
        (width = '308px')),
        data.weatherdetail.length > 2 &&
          ((url = `${ShipxyOptions.weather.icon_base_url}/${imageUrl.bg72}`),
          (width = '474px'))

      let html = `<div class="weather-tooltip" style="background: url(${url}) no-repeat !important; width: ${width};">
                    <div class="area_info">
                      ${
                        !CanvasShipUtils.isEmpty(data.seaarea) &&
                        `<div class="title">${data.seaarea}</div>`
                      }
                      ${
                        !CanvasShipUtils.isEmpty(data.publishtime) &&
                        `<div class="field yubaotime">预报时间: ${data.publishtime}</div>`
                      }
                      <div class="field ml0">${data.forecastaging_str}</div>
                    </div>`

      for (let i = 0; i < data.weatherdetail.length; i++) {
        const weatherdetail = data.weatherdetail[i]
        html += '<div class="day_info">'
        if (!CanvasShipUtils.isEmpty(weatherdetail.meteorological)) {
          const imageUrl = this._judgeImage(
            weatherdetail.meteorological_icon || ''
          )
          html += `<div class="field icon ml0"><img src="${ShipxyOptions.weather.icon_base_url}/${imageUrl.icon_info}"></div>`
          data.weatherdetail[i].imageUrl = imageUrl
        }
        html += `<div class="field date ml0">${weatherdetail.publishtime}</div>`
        let className = ''
        0 == i && (className = 'ml0')
        if (!CanvasShipUtils.isEmpty(weatherdetail.meteorological))
          html += `<div class="field ${className}">天气：${weatherdetail.meteorological}</div>`
        if (!CanvasShipUtils.isEmpty(weatherdetail.windpower))
          html += `<div class="field ${className}">风力：${weatherdetail.windpower}(级)</div>`
        if (!CanvasShipUtils.isEmpty(weatherdetail.winddirection)) {
          html += `<div class="field ${className}">风向：${weatherdetail.winddirection}</div>`
        }
        if (!CanvasShipUtils.isEmpty(weatherdetail.visibility)) {
          html += `<div class="field ${className}">能见度：${weatherdetail.visibility}(千米)</div>`
        }
        if (!CanvasShipUtils.isEmpty(weatherdetail.waveheight))
          html += `<div class="field ${className}">浪高：${weatherdetail.waveheight}(米)</div>`
        html += '</div>'
      }
      html += '</div>'
      const mobisCbRes = merge(data, { background: url })
      if (!isMobile.value) {
        marker.bindTooltip(html, {
          permanent: false,
          opacity: 1,
          offset: [20, -10], // Tooltip 相对于 Marker 的偏移量（像素），[水平偏移, 垂直偏移]
          className: 'weather-bindTooltip',
        })
        const tooltip = marker.getTooltip() as any
        if (tooltip) {
          tooltip._initLayout()
          tooltip._container.style.padding = 0
          tooltip._container.style.border = 'none'
          tooltip._container.style.background = 'transparent'
          tooltip._container.style.boxShadow = 'none'
        }
      }
      this._layerGroup.addLayer(marker)
    }
  }

  _judgeImage(url: string) {
    const key = url.split(' ')[0]
    return key in ShipxyOptions.weather.icon_types
      ? (ShipxyOptions.weather.icon_types as any)[key]
      : ShipxyOptions.weather.icon_types.多云
  }

  _drawSeaForecasts() {
    this._layerGroup.remove()
    this._layerGroup = L.featureGroup().addTo(this._map)
    const zoom = this._map.getZoom()
    if (zoom >= 6) {
      for (let i = 0; i < this._seaForecasts_yanan.length; i++)
        this._drawSeaForecast(this._seaForecasts_yanan[i])
    }
    if (zoom >= 4) {
      for (let i = 0; i < this._seaForecasts_jinhai.length; i++)
        this._drawSeaForecast(this._seaForecasts_jinhai[i])
    }
    if (zoom >= 1) {
      for (let i = 0; i < this._seaForecasts_yuanhai.length; i++)
        this._drawSeaForecast(this._seaForecasts_yuanhai[i])
    }
    for (let i = 0; i < this._seaForecasts.length; i++)
      this._drawSeaForecast(this._seaForecasts[i])
  }

  close() {
    if (this._layerGroup) {
      this._layerGroup.remove()
      this._seaForecasts = []
    }
    this.removeEventCallbackListener()
  }
  addEventCallbackListener(listener: (params: any) => void) {
    this.callbackListener = listener
  }
  removeEventCallbackListener() {
    this.callbackListener = undefined
  }
}

// 导出 SeaAreaForecastService 类，以便在其他模块中使用
export { SeaAreaForecastService, SeaForecast }
